<template>
  <div>
    <ExportBuilder v-if="externalSoftware == 0"></ExportBuilder>
    <AbsenceExport v-if="externalSoftware == 1"></AbsenceExport>
    <div
      v-if="externalSoftware != 1 && externalSoftware != 0"
      style="font-size: 22px; font-weight: bold; padding: 60px"
    >
      {{ $t('export.comp.exportNotAvailable') }}
    </div>
  </div>
</template>
<script>
import ExportBuilder from "./ExportBuilder.vue";
import AbsenceExport from "../../views/AbsenceExport.vue";
import { mapState, mapGetters } from "vuex";
export default {
  components: {
    ExportBuilder,
    AbsenceExport,
  },
  name: "ExportDaily",
  data() {
    return {
      mode: "daily",
    };
  },
  computed: {
    ...mapGetters(["externalSoftware"]),
  },
  watch: {},
  mounted() {
    this.refresh();
  },
  methods: {
    refresh: function () {},
  },
};
</script>
<!-- Add "scoped" attriemployeete to limit CSS to this component only -->
<style scoped></style>
